var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13375 14.0002H0.23125V4.6533H3.13375V14.0002ZM1.68094 3.3783C0.752813 3.3783 0 2.60955 0 1.68143C6.64312e-09 1.23561 0.177098 0.80806 0.492335 0.492823C0.807572 0.177587 1.23513 0.000488281 1.68094 0.000488281C2.12675 0.000488281 2.5543 0.177587 2.86954 0.492823C3.18478 0.80806 3.36188 1.23561 3.36188 1.68143C3.36188 2.60955 2.60875 3.3783 1.68094 3.3783ZM13.9969 14.0002H11.1006V9.45018C11.1006 8.3658 11.0787 6.97518 9.59156 6.97518C8.0825 6.97518 7.85125 8.1533 7.85125 9.37205V14.0002H4.95188V4.6533H7.73562V5.9283H7.77625C8.16375 5.19393 9.11031 4.41893 10.5225 4.41893C13.46 4.41893 14 6.3533 14 8.8658V14.0002H13.9969Z",
    fill: "#D1D5DB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFooter);
export default __webpack_public_path__ + "static/media/LinkedinFooter.a7914b4a1193b580f673f25aa01a6125.svg";
export { ForwardRef as ReactComponent };